module.exports = __webpack_public_path__ + "static/media/checkgreen.43390470.svg";